import React from 'react';
// import './navbar.css'
import Logo from '../../../images/logo.png'

export default function Navbar() {
  return (
    <div className='absolute w-full border-t-4 border-[#fdb814] bg-white '>
      <div className='border-b border-gray-300'>
        <div className='flex mx-auto'>
        <span className='py-3 px-4 text-lg font-semibold text-[#fdb814] flex items-center'>
          <img
            src={Logo}
            alt="Logo"
            height={35}
            width={35}
            className='inline-block align-middle mr-2'
          />
          <span className='ml-2'>PROVIDUS API SANDBOX</span>
        </span>
        </div>
      </div>
    </div>
  );
}